import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { BOX_IMG, CHECKOUT_URL } from './constants';
const modules = [{
  title: 'COMPLETE SESSION LIBRARY™',
  description: 'Una libreria professionale con sessioni complete già pronte dedicate a forza, equilibrio, mobilità, coordinazione, resistenza, prevenzione delle cadute e benessere funzionale. Include lezioni da 30, 45 e 60 minuti, circuiti, allenamenti individuali e di gruppo, varianti per diversi livelli e strutture complete immediatamente utilizzabili.'
}, {
  title: 'PROGRESSIVE TRAINING PROGRAMS™',
  description: 'Programmi completi di 4, 8, 12 e 16 settimane con obiettivi già definiti, progressioni organizzate, distribuzione del lavoro, esercizi selezionati e pianificazioni professionali pronte da applicare con clienti senior di differenti livelli funzionali.'
}, {
  title: 'EXERCISE PROGRESSION LIBRARY™',
  description: 'Una vasta biblioteca professionale di esercizi organizzati per obiettivo, capacità funzionale, livello, attrezzatura e tipologia di lavoro. Include progressioni, regressioni, varianti e sostituzioni immediate per adattare rapidamente ogni allenamento.'
}, {
  title: 'FUNCTIONAL ASSESSMENT TOOLKIT™',
  description: 'Schede professionali di valutazione, test funzionali, monitoraggio dei progressi, registri, report e strumenti pratici già pronti per valutare mobilità, equilibrio, forza, coordinazione e miglioramenti durante tutto il percorso di allenamento.'
}, {
  title: 'EXERCISE ADAPTATION SYSTEM™',
  description: 'Un sistema completo per modificare rapidamente esercizi e allenamenti in base alle capacità, alle limitazioni e al livello funzionale di ogni cliente senior. Include adattamenti immediati, regressioni, progressioni e soluzioni pratiche per lavorare con gruppi eterogenei senza improvvisare.'
}, {
  title: 'PROFESSIONAL COACHING RESOURCES™',
  description: 'Planner professionali, registri, schede operative, modelli di pianificazione, fogli di monitoraggio, documentazione, checklist e strumenti organizzativi già pronti da utilizzare ogni giorno per gestire il tuo lavoro con maggiore efficienza e professionalità.'
}];
export function ModulesSection() {
  return <section className="py-8 px-4 sm:px-6 bg-white" data-id="element-84" data-mp="29594cdcyws0j">
      <div className="text-center mb-5" data-id="element-85" data-mp="296u3kga88z4q">
        <p className="text-[11px] sm:text-sm font-heading font-bold text-sage uppercase tracking-widest mb-1" data-id="element-86" data-mp="36szp7duxgveo">
          La Soluzione che Stavi Cercando
        </p>
        <h2 className="text-xl sm:text-3xl font-heading font-extrabold text-petrol leading-tight uppercase mb-2" data-id="element-87" data-mp="31uput5h11yu4">
          Un Sistema Completo 6-in-1 per Allenatori di Fitness Senior
        </h2>
        <div className="inline-block bg-petrol text-white px-4 py-1.5 rounded mb-3" data-id="element-88" data-mp="2ssyr2661s22w">
          <p className="font-heading font-bold text-xs sm:text-sm tracking-widest uppercase" data-id="element-89" data-mp="1lggacmfwou8k">
            🏋️ SENIOR FITNESS COACH PRO™
          </p>
        </div>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block cursor-pointer mb-3" data-id="element-90" data-mp="3t1yhag7klgrr">
          <img src={BOX_IMG} alt="SENIOR FITNESS COACH PRO — Sistema Completo 6-in-1" className="w-full max-w-[220px] sm:max-w-xs mx-auto object-contain drop-shadow-lg hover:scale-[1.02] transition-transform duration-300" data-id="element-91" data-mp="vjkewfcgspp" />
        </a>

        <p className="max-w-2xl mx-auto text-warmgray text-[13px] sm:text-base leading-relaxed" data-id="element-92" data-mp="fm0lufrzbiml">
          Più di una raccolta di esercizi. Più di una semplice libreria di
          allenamenti.{' '}
          <span className="font-semibold text-petrol" data-id="element-93" data-mp="oo0050bm08lu">
            SENIOR FITNESS COACH PRO™ è un sistema professionale progettato per
            permetterti di preparare lezioni complete in pochi minuti,
            organizzare programmi di allenamento efficaci e lavorare con un
            metodo già pronto da applicare ogni giorno con i tuoi clienti senior.
          </span>
        </p>
      </div>

      <div className="flex flex-col gap-2.5 max-w-3xl mx-auto" data-id="element-94" data-mp="201n8q7vl4mpe">
        {modules.map(module => <div key={module.title} className="bg-cream border border-gold/30 rounded-lg p-3.5 sm:p-4 flex gap-2.5 items-start" data-id="element-95" data-mp="1v453oskourmo">
            <CheckCircle2Icon className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-96" data-mp="253maxefl9dkr" />
            <div data-id="element-97" data-mp="1hcgvh0dk8naz">
              <h3 className="text-sm sm:text-base font-heading font-bold text-petrol leading-tight mb-1" data-id="element-98" data-mp="1he1ryvjfqgbh">
                {module.title}
              </h3>
              <p className="text-warmgray text-[13px] sm:text-sm leading-relaxed" data-id="element-99" data-mp="1cc2ozmrlxlf2">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}